import { CurrentAppViewOptions } from 'src/interfaces/store.types';
import { useCurrentAppViewSelector } from 'src/store/features';

export const useIsMiddleSchoolView = () => {
  const currentAppView = useCurrentAppViewSelector();

  return currentAppView === CurrentAppViewOptions.MIDDLE_SCHOOL;
};
